// Google Analytics Configuration
export const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID || 'G-XXXXXXXXXX';

// Environment check
export const isProduction = import.meta.env.PROD;
export const isDevelopment = import.meta.env.DEV;

// Only enable analytics in production
export const shouldTrackAnalytics = isProduction && GA_MEASUREMENT_ID !== 'G-XXXXXXXXXX'; 